import { render, staticRenderFns } from "./AccueilImg.vue?vue&type=template&id=4dd0725e&"
import script from "./AccueilImg.vue?vue&type=script&lang=js&"
export * from "./AccueilImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports